import SidebarCustomSections from "../common/custom-sections";
export default class SidebarAnonymousCustomSections extends SidebarCustomSections {
    anonymous = true;
}
